import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import React, { useState, useEffect } from "react";

export const WidgetReservasResumen = ({ Fecha, WidgetKey }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_ResumenLeible } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_VEN_Reservas_Cabecera_ResumenLeible(await FormateoFechaPara_yyyyMMdd(Fecha), await FormateoFechaPara_yyyyMMdd(Fecha));

      const resumen = resultData.data?.[0]?.[""] ?? "-"; // si no hay, "-"

      setData(resumen);
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  return (
    <div>
      {data && data.length > 0 && (
        <div className="widgetDobleAncho">
          <div className="title">
            {(
              <AccountBalanceWalletOutlinedIcon
                className="icon"
                style={{
                  backgroundColor: "rgba(128, 0, 128, 0.2)",
                  color: "purple",
                  width: "30px",
                  height: "30px",
                  margin: "0px 15px 0px 0px "
                }}
              />
            )} {"RESUMEN DE RESERVAS"}
          </div>
          <br />
          <span className="title">{data || "-"}</span>
          <br />

          <br />
          <a href={"VEN_Reservas_"} className="tituloLink">
            {"Ver Reservas"}
          </a>
        </div >
      )}
    </div>
  );
};
